/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionaryType } from 'app/shared/model/clinical-dictionary-type.model';

export interface IClinicalDictionary {
  id?: string;
  entityid?: string | null;
  entityType?: string | null;
  name?: string;
  value?: string;
  createdBy?: string;
  createDate?: number;
  lastUpdated?: number;
  lastModifiedBy?: string;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  timestampEntry?: number;
  dictionaryType?: IClinicalDictionaryType | null;
  parent?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IClinicalDictionary> = {
  active: false,
};
